import React, { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import { Icon, Classes } from "@blueprintjs/core";
import axios from "axios";
import { config } from './../../config';

import style from "./index.module.scss";
import { useSearchParams } from "react-router-dom";

function EmailPreview({ bodyData, prevPopup, setPrevPopup, templateType }) {
  const [htmlContent, setHtmlContent] = useState("");
  const [searchParams] = useSearchParams();

  const reminderTypeFromState = searchParams.get("reminderType");

  const getReminderTypeText = (reminderType, templateType) => {
    switch (reminderType) {
      case "TIMESHEET_CREATION_REMINDER":
        switch (templateType) {
          case "reminder":
            return "createAndSubmitTimesheet";
          case "alert":
            return "creationPeriodEndAlert";
          case "expiration":
            return "creationperiodExpired";
          default:
            return "";
        }

      case "TIMESHEET_SUBMISSION_REMINDERS":
        switch (templateType) {
          case "reminder":
            return "submitTimesheetReminder";
          case "alert":
            return "timesheetSubmissionEndAlert";
          case "expiration":
            return "submissionPeriodExpired";
          default:
            return "";
        }

      case "TIMESHEET_REVIEW_APPROVE_REMINDER":
        switch (templateType) {
          case "alert":
            return "timesheetReviewEndAlert";
          case "expiration":
            return "timesheetReviewExpired";
          default:
            return "";
        }

      default:
        return "";
    }
  };

  const handleClose = () => setPrevPopup(false);

  useEffect(() => {
    if (prevPopup) {
      fetchEmailTemplateContent();
    }
  }, [prevPopup]);

  const baseURL =
    `${config.apiUrl}/notification-service`;

  const fetchEmailTemplateContent = async () => {
    try {
      const response = await axios.get(`${baseURL}/emailtemplate/content`, {
        params: {
          templateName: getReminderTypeText(
            reminderTypeFromState,
            templateType
          ),
        },
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let rawHtml = response?.data || "";
      const bodyRegex =
        /<\#if\s+(?:templateBody|body)\?\?>[\s\S]*?<\#else>([\s\S]*?)<\/#if>/gi;
      const replacedHtml = rawHtml.replace(bodyRegex, bodyData);

      const parser = new DOMParser();
      const doc = parser.parseFromString(replacedHtml, "text/html");

      doc.querySelectorAll("a").forEach((a) => {
        a.removeAttribute("href");
        a.setAttribute(
          "style",
          (a.getAttribute("style") || "") +
            "; pointer-events: none; cursor: not-allowed;"
        );
      });

  
      setHtmlContent(doc.documentElement.innerHTML);
    } catch (error) {
      console.error("Error fetching email template:", error);
      setHtmlContent("<p>Error loading content</p>");
    }
  };

  return (
    <Modal
      open={prevPopup}
      onClose={handleClose}
      aria-labelledby="email-preview-title"
      aria-describedby="email-preview-description"
    >
      <div
        style={{
          position: "absolute",

          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          // backgroundColor: "#fff",
          // padding: "20px 24px",
          // boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
          borderRadius: 8,
          width: "80%",
          maxHeight: "99vh",
          overflowY: "auto",
          outline: "none",
        }}
      >
        <div className={Classes.DIALOG_BODY} style={{ position: "relative" }}>
          <Icon
            icon="cross"
            onClick={handleClose}
            style={{
              position: "absolute",
              top: "9%",
              right: "15%",
              cursor: "pointer",
              fontSize: 20,
              color: "#555",
            }}
            title="Close"
          />

          <div
            id="email-preview-description"
            className={style.emailContentWrapper}
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
        </div>
      </div>
    </Modal>
  );
}

export default EmailPreview;
